
<template>
<footer class="footer-buttons" :class="{'footer-buttons--center': center}">
    <slot></slot>
</footer>
</template>

<script>
export default {
    name: "FooterButtons",
    props: {
        center: Boolean
    }
}
</script>

<style lang="scss" scoped>
.footer-buttons {
    margin-top: auto;
    padding-top: 30px;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    position: relative;

    .btn {
        min-width: 100px;
    }

    &--center {
        justify-content: center;
    }

    @include mobile-only {
        flex-direction: column;

        .btn {
            width: 100%;
            height: 50px;
        }
    }
}
</style>
